import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('hello-world-app')
export class HelloWorldApp extends LitElement {
  static styles = css`
    :host {
      max-width: 1280px;
      margin: 0 auto;
      padding: 3rem 2rem;
      text-align: center;
      font-family: system-ui, -apple-system, sans-serif;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }

    h1 {
      font-size: 3.5em;
      line-height: 1.2;
      color: white;
      margin-bottom: 1rem;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }

    .subtitle {
      font-size: 1.2em;
      color: rgba(255, 255, 255, 0.9);
      margin-bottom: 3rem;
      font-weight: 300;
    }

    .card {
      background: linear-gradient(135deg, rgba(147, 168, 255, 0.25), rgba(171, 135, 209, 0.25));
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      border-radius: 16px;
      padding: 3rem 2rem;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(255, 255, 255, 0.4);
      max-width: 500px;
      width: 100%;
    }

    button {
      border-radius: 12px;
      border: none;
      padding: 1em 2.5em;
      font-size: 1.1em;
      font-weight: 600;
      font-family: inherit;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    button:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
    }

    button:active {
      transform: translateY(0);
    }

    button:focus,
    button:focus-visible {
      outline: 3px solid rgba(102, 126, 234, 0.5);
      outline-offset: 2px;
    }

    .icon {
      font-size: 4em;
      margin-bottom: 1rem;
    }
  `

  private handleGoToHealth() {
    window.history.pushState({}, '', '/health')
    window.dispatchEvent(new PopStateEvent('popstate'))
  }

  render() {
    return html`
      <h1>💰 Finance Suite - PoC</h1>
      <p class="subtitle">Welcome to your financial management solution</p>
      
      <div class="card">
        <div class="icon">🩺</div>
        <button @click=${this.handleGoToHealth}>
          View System Health
        </button>
      </div>
    `
  }
}